import React, { useEffect } from 'react';
import { getMenuPath, escapeHtml } from '../utils/bannerUtils';

/**
 * 유형 4 - 타이틀 + 배경 이미지 풀스크린
 * 원본: banner-fullscreen fragment
 *
 * @param {string} title - 페이지 타이틀
 * @param {Array} breadcrumbPath - breadcrumb 경로 배열
 * @param {string} bgImage - 배경 이미지 경로 (기본값: '/assets/images/page/banner_bg.jpg')
 * @param {string} subtitle - 서브타이틀
 * @param {string} overlay - 오버레이 타입 ('dark', 'light', 'blue', 'gradient', 기본값: 'dark')
 */
const BannerFullscreen = ({ title, breadcrumbPath, bgImage = '', subtitle = '', overlay = 'dark' }) => {
  useEffect(() => {
    // AOS 초기화
    if (typeof window.AOS !== 'undefined') {
      requestAnimationFrame(() => {
        window.AOS.refreshHard();
      });
    }
  }, []);

  const pageTitle = title || '페이지';
  const bgImageValue = bgImage || '/assets/images/page/banner_bg.jpg';
  const menuPath = getMenuPath(breadcrumbPath);
  const hasSubtitle = subtitle && subtitle.trim() !== '';

  const overlays = {
    dark: 'rgba(0,0,0,0.3)',
    light: 'rgba(255,255,255,0.15)',
    blue: 'rgba(102, 126, 234, 0.35)',
    gradient: 'linear-gradient(135deg, rgba(102, 126, 234, 0.4) 0%, rgba(118, 75, 162, 0.4) 100%)'
  };

  const overlayValue = overlays[overlay] || overlays.dark;
  const isGradient = overlay === 'gradient';

  return (
    <>
      <style>
        {`
          .banner-fullscreen {
            position: relative;
            min-height: 400px;
            background-image: url('${escapeHtml(bgImageValue)}');
            background-size: cover;
            background-position: center;
            background-attachment: fixed;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
          }
          .banner-fullscreen::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: ${isGradient ? overlayValue : overlayValue};
            z-index: 1;
          }
          .banner-fullscreen .container {
            position: relative;
            z-index: 2;
            text-align: center;
            color: ${overlay === 'light' ? '#333' : 'white'};
          }
          .banner-fullscreen .banner-title {
            font-size: 3.5rem;
            font-weight: 800;
            margin-bottom: 20px;
            text-shadow: 3px 3px 6px rgba(0,0,0,0.5);
          }
          .banner-fullscreen .banner-subtitle {
            font-size: 1.3rem;
            margin-bottom: 25px;
            font-weight: 300;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
          }
          .banner-fullscreen .banner-breadcrumb {
            font-size: 1rem;
            display: inline-block;
            padding: 10px 25px;
            background: ${overlay === 'light' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.2)'};
            border-radius: 25px;
            backdrop-filter: blur(10px);
            color: ${overlay === 'light' ? '#333' : 'white'};
          }
        `}
      </style>
      <div className="banner-fullscreen" data-aos="fade-right" data-aos-delay="100">
        <div className="container">
          <h1 className="banner-title" data-aos="fade-left" data-aos-delay="200">
            {escapeHtml(pageTitle)}
          </h1>
          {hasSubtitle && (
            <p className="banner-subtitle">{escapeHtml(subtitle)}</p>
          )}
          <div className="banner-breadcrumb" data-aos="fade-right" data-aos-delay="200">
            {menuPath}
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerFullscreen;

